import React, { useContext, useState } from 'react';

import { UpRightFromSquare } from '@/assets/icons';
import { AsaphButton } from '@/components/shared/Button';
import { FormInput, TextInput } from '@/components/shared/Inputs';
import { PasswordInput } from '@/components/shared/Inputs/Password';
import { useErrorHandler } from '@/hooks/useErrorHandler';
import { useAnalyticsEvent } from '@/providers/AnalyticsProvider';
import { Environments, useEnvironment } from '@/providers/EnvironmentProvider';
import { FormHelperText, SvgIcon } from '@material-ui/core';
import axios, { AxiosError } from 'axios';
import { Formik } from 'formik';
import { useSnackbar } from 'notistack';
import * as Yup from 'yup';

import styles from '../../../Login/LoginPage.module.scss';
import { CopilotContext, CopilotState } from '../../CopilotPage';
import copilotStyles from '../../CopilotPage.module.scss';

const signUpValidationSchema = Yup.object().shape({
	email: Yup.string()
		.email('Must be a valid email address')
		.required('Email address is required'),
});

const EmailForm: React.FC<{ onChange: (email: string) => void }> = ({
	onChange,
}) => {
	const {
		api: { url },
		environment,
	} = useEnvironment();
	const { handleError } = useErrorHandler();
	const [emailFired, setEmailFired] = useState(false);
	const fireEnterEmailEvent = useAnalyticsEvent('Login_Enter_Email');
	const fireSendCodeEvent = useAnalyticsEvent('Login_Send_Code');
	const { setState } = useContext(CopilotContext);

	return (
		<Formik
			key="asaphSignUn"
			initialValues={{
				email: '',
			}}
			validationSchema={signUpValidationSchema}
			onSubmit={async (values, formikHelpers) => {
				try {
					const res = await axios.post(
						`${url}/copilot/link-user/get-link`,
						{
							email: values.email,
						},
					);
					fireSendCodeEvent();
					onChange(values.email);
				} catch (err) {
					handleError({
						error: err,
						errorCode: 'LoginError',
						friendlyMessage:
							'Something went wrong. Please try again later.',
					});
				}
			}}
		>
			{({
				handleSubmit,
				handleChange,
				values,
				isSubmitting,
				touched,
				errors,
			}) => (
				<form
					onSubmit={handleSubmit}
					id="asaphSignIn"
					style={{ height: '100%' }}
				>
					<div className={copilotStyles['flex-between']}>
						<div className={copilotStyles['form-container']}>
							<div className={copilotStyles['blurb']}>
								Enter your existing Asaph account email and
								we’ll send you a one-time code to verify you.
							</div>
							<div className="vsb-20" />
							<FormInput
								className={copilotStyles.input}
								id="email"
								name="email"
								type="email"
								placeholder="Email"
								onChange={(e) => {
									handleChange(e);
									if (!emailFired) {
										fireEnterEmailEvent();
										setEmailFired(true);
									}
								}}
								value={values.email}
								fullWidth
							/>
							<div className="vsb-20">
								{!!errors.email && touched.email && (
									<FormHelperText
										error={true}
										classes={{
											root: 'authentication-error-text',
										}}
									>
										{errors.email}
									</FormHelperText>
								)}
							</div>
						</div>
						<div className={copilotStyles['accept-row']}>
							<AsaphButton
								label="Back"
								onClick={() =>
									setState(CopilotState.UserNotFound)
								}
								color="grey"
							/>
							<AsaphButton
								label="Get One-time Code"
								type="submit"
								color="blue"
								fullWidth
								disabled={isSubmitting}
							/>
						</div>
					</div>
				</form>
			)}
		</Formik>
	);
};

export default EmailForm;
